import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: { main: '#00377B' },
    secondary: { main: '#4cc5f2' },
  },
});
